import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import '@fmr-ap152550/dom/lib/dom-authenticators.min.js';
import '@fmr-ap152550/dom/lib/dom-core.min.js';
import '@fmr-ap152550/dom/lib/dom-preset-react.min.js';
import { signin } from '@fmr-ap152550/dom/lib/dom-signin.min.js';
import { CookieService } from 'ngx-cookie-service';
import { constants } from '../constants';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent implements OnInit {
  readonly #window = inject(DOCUMENT).defaultView;
  readonly #route = inject(ActivatedRoute);
  readonly #router = inject(Router);
  private readonly cookies = inject(CookieService);
  readonly sessionCookie = signal<string>(this.cookies.get('SESSION_SCTX')).asReadonly();

  ngOnInit() {
    if (this.#window) {
      this.#window.onDomFinish = (data) => {
        const onDomFinishData = JSON.parse(data);
        if (onDomFinishData.context === 'Prime') {
          this.#window?.location.assign(constants.portalUrl);
        }
      };


      this.#window.onDomCancel = (param) => {
        console.log('onDomCancel called with param: ', param);
        this.#router.navigate(['login']);
      };

      const onResetPasswordSuccess = () => {
        console.log('onSuccessFullResetPassword called');
        this.#router.navigate(['login']);
      };

      this.#window.onSuccessFullResetPassword = onResetPasswordSuccess;
      this.#window.onSuccessfullResetPassword = onResetPasswordSuccess;

    }




    this.#route.queryParamMap.subscribe(params => {
      const eventType = params.get('event_type');
      const ccpStatus = params.get('ccpStatus');
      if (eventType && eventType !== '' && eventType === 'password_reset') {

        signin({
          ecaapEndpoint: constants.baseUrl,
          appId: 'PRIMESRVPORTAL',
          appName: 'AP010025-Prime Portal',
          journey: 'password_reset',
          subEventType: 'prime_password_reset',
          ccpStatus: ccpStatus?.toString() ?? 'false',
          SESSION_CTX: this.sessionCookie(),
          repPhone: '800-343-3548',
          businessSMSText: 'Fidelity Investments',
          identityEndpoint: '#/username',
          isCallRepEnabled: true,
          allowInteraction: false
        });
      } else {
        signin({
          ecaapEndpoint: constants.baseUrl,
          appId: 'PRIMESRVPORTAL',
          appName: 'AP010025-Prime Portal',
          journey: 'LOGIN',
          subEventType: 'prime_login',
          repPhone: '800-343-3548',
          businessSMSText: 'Fidelity Investments',
          identityEndpoint: '#/username',
          resetPasswordEndpoint: '#/username',
        });
      }
    })




  }
}
